import { Table, Popover as PopoverAntd } from "antd";
import { Medium } from "utilFunctions/Constants/Constants";
import ViewIcon from "Assets/Icons/ViewIcon";
import { subjectColors } from "utilFunctions/Constants/subjectColorCodes";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import "./index.css";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
export const returnColor = (subject: string) => {
  const selectedSub = subjectColors.filter(
    (ele: any) => ele?.subject?.toLowerCase() == subject?.toLowerCase()
  );
  if (selectedSub.length) {
    return selectedSub[0].colorCode;
  } else {
    return "gray";
  }
};
export const DivStyledStatus = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 12px;
  padding: 4px 11px;
  color: #ffffff;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  width: fit-content;
`;
// const tableHeading = [
//   { label: "Stream", value: "sid" },
//   { label: "Class", value: "cid" },
//   { label: "Subject", value: "sjId" },
//   { label: "Board", value: "bid" },
//   { label: "Medium", value: "lang" },
// ];
export interface MyLibraryTableInterface {
  loading: boolean;
  data: any[];
  setSortColumn: any;
  sortColumn: string;
  setSortOrder: any;
  sortOrder: string;
  masters: any;
  userInfo: any;
  pagination: any;
  setPagination: any;
  onPageChange: any;
  setItemsPerPage: any;
}
const MyLibraryTable = ({
  loading,
  data,
  masters,
  userInfo,
  pagination,
  setPagination,
  onPageChange,
  setItemsPerPage,
}: MyLibraryTableInterface) => {
  const navigate = useNavigate();
  const returnName = (array: any, id: number) => {
    return array?.find((ele: any) => ele.value == id)?.label;
  };
  const columns: any = [
    {
      title: "Stream",
      dataIndex: "sid",
      fixed: "left",
      render: (_: any, record: any) => {
        return (
          <span className="tableIdStyle">
            {returnName(userInfo?.userStreams, record.sid)}
          </span>
        );
      },
    },
    {
      title: "Class",
      dataIndex: "class",
      render: (_: any, record: any) => {
        return <span>{returnName(masters?.classes, record.cid)}</span>;
      },
    },

    {
      title: "Subjects",
      dataIndex: "lang",
      render: (_: any, column: any) => {
        return (
          <span>
            {" "}
            {column && returnName(userInfo?.subjectsListing, column.sjId) && (
              <DivStyledStatus
                color={returnColor(
                  returnName(userInfo?.subjectsListing, column.sjId)
                )}
              >
                {returnName(userInfo?.subjectsListing, column.sjId)}
              </DivStyledStatus>
            )}
          </span>
        );
      },
    },
    {
      title: "Boards",
      dataIndex: "boards",
      render: (_: any, record: any) => {
        return <span>{returnName(masters?.boards, record.bid)}</span>;
      },
    },
    {
      title: "Medium",
      dataIndex: "lang",
      render: (_: any, record: any) => {
        return <span>{returnName(Medium, record.lang)}</span>;
      },
    },
    {
      title: "Actions",
      dataIndex: "title",
      render: (_: any, record: any) => {
        return (
          <div
            className="actionButtonHoverEffect"
            onClick={() => {
              navigate("/admin/mylibrary/" + record.id, {
                replace: false,
              });
            }}
          >
            <PopoverAntd placement="leftTop" content={() => <>View library</>}>
              <ViewIcon
                id={"viewPlannertooltip"}
                data-toggle="tooltip"
                data-trigger="hover"
                className="cursorHoverCSS"
              ></ViewIcon>
            </PopoverAntd>
          </div>
        );
      },
    },
  ];
  const handleTableChange = (paginations: any, filters: any, sorter: any) => {
    const sortField = sorter.field || pagination.sortField;
    let sortOrder = pagination.sortOrder;
    if (sorter.order !== undefined) {
      sortOrder = sorter.order === "descend" ? "DESC" : "ASC";
    }
    const currentPage =
      pagination.pageSize != paginations.pageSize ? 1 : paginations.current;
    onPageChange(paginations.current);
    setItemsPerPage(paginations.pageSize);
    setPagination({
      ...paginations,
      current: currentPage,
      sortField,
      sortOrder: sortOrder,
    });
  };
  return (
    <TableLayoutAntd isLoader={loading}>
      <Table
        scroll={{ x: "max-content" }}
        bordered
        size="small"
        columns={columns}
        dataSource={data}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </TableLayoutAntd>
  );
};
export default MyLibraryTable;
